import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getAdmin(c, id)
  {
    let url = apiUrl + 'Admin/Get?id=' + id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getRoles()
  {
    let url = apiUrl + 'getAutoServiceRoles';
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getUserInfo()
  {
    let url = apiUrl + 'getUserInfo';
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }

};

export default {
  namespaced: true,
  actions
}